module.exports = __webpack_public_path__ + "img/美基元医疗美容.794da99.png";